<template>
  <div >
    <div class="pad5">
      <h1>使用协议</h1>
      <p>在登录和使用金榜高考平台（以下统称为“本平台”）的任何功能之前，用户首先必须同意此协议和本平台的免责声明。用户登陆使用本平台即视为用户已阅读并同意接受本协议约束。此协议在必要时将进行修订，且毋需另行通知。修订后的协议一旦在网页上公布即有效代替原来的用户协议。</p>
      <h4>一、内容</h4>
      <p>本平台功能分为免费和付费两部分，免费功能包括但不仅限于：院校查询、专业查询、三位一体等；付费功能包括但不仅限于一键志愿、模拟录取、学业记录等。</p>
      <h4>二、绑卡</h4>
      <p>1.用户绑卡分两种情况</p>
      <p>线下购买金榜高考VIP卡后，请在激活VIP页面绑定激活码，注意绑定的手机号码是否正确，未开通VIP的用户将无法使用本系统的付费功能；</p>
      <p>线上购买后即与订单中的手机号码绑定，无须进行绑卡操作。</p>
      <p>2.用户绑卡后需完善基本信息，其中成绩单分两种情况</p>
      <p>（1）非高考季：每年9月1日至下一年高考出分前，本系统可无限次修改成绩。若仅修改成绩不保存新的方案，不会影响原成绩保存的志愿方案；</p>
      <p>（2）高考季：每年高考出分后至当年8月31日前，1个会员帐号仅提供1份正式成绩的保存，请确保此份成绩是当年高考真实成绩，保存后高考季期间不得修改（该成绩信息包括“分数、位次、选考科目”）；</p>
      <p>3.除非因为系统本身的问题导致付费服务无法正常提供，用户支付的所有费用均不能退款</p>
      <h4>三、知识产权</h4>
      <p>1、志愿梯次指数：根据以“院校+专业”为志愿填报单位的新高考政策，重新将文理分科录取的院校及其各专业位次梳理成新高考下文理不分科录取的院校专业梯次指数。志愿梯次指数是金华软谷教育科技有限公司自主研发的知识产权，享受中华人民共和国法律法规和相应的国际条约保护。</p>
      <p>2、本页面的文字、图片、音频、视频等版权均归金华软谷教育科技所有，本页面的一切著作权、商标权、专利权、商业秘密等知识产权，均受中华人民共和国法律法规和相应的国际条约保护。</p>
      <p>3、未经金榜高考或相关权利人书面许可，用户不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上诉知识产权。</p>
      <h4>四、隐私</h4>
      <p>1、未经用户本人同意，金榜高考不会对外公开或向第三方提供用户的个人资料及用户在使用本平台时存储在本平台的非公开内容。</p>
      <p>2、在不透露用户隐私资料的前提下，金榜高考有权对用户数据库进行分析应用。</p>
    </div>
  </div>
</template>
<script>
    export default {
        name: "xieyi"
    }
</script>

<style scoped>
.pad5{
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/xieyi.vue